import * as React from 'react'
import { Link } from 'widgets-for-react'

type ExternalLink = {
  [key: string]: any
  to: string
  children?: any
  onClick?: () => void
}

export const ExternalLink = (props: ExternalLink) => {
  const linkProps = { ...props }
  const { type, to, ...rest } = linkProps
  return /^https?:\/\//.test(to) ? (
    <a {...rest} href={to} target="_blank" rel="noopener noreferrer">
      {props.children}
    </a>
  ) : /.pdf$/.test(to) || /.docx?$/.test(to) || /.pptx?$/.test(to) || /.xlsx?$/.test(to) ? (
    <a {...rest} href={to} target="_blank" rel="noopener noreferrer">
      {props.children}
    </a>
  ) : (
    <Link {...rest} to={to} >
      {props.children}
    </Link>
  )
}
